import { gsap, Power2 } from 'gsap'
import Experience from '../../Experience'
import ScrollEvent from '../ScrollEvent'

export default class AboutAnimations {

    hologramPlayed = false

    parameters = {
        skillsAdditionalDelay: .2,
        aboutAdditionalDelay: .45,
    }

    domElements = {
        aboutSection: document.getElementById('about-section'),
        profile: document.getElementById('about-profile'),
        skills: document.getElementById('about-skills'),
        bio: document.getElementById('about-bio'),
        avatar: document.querySelector('.about-avatar img'),
        avatarScan: document.querySelector('.about-avatar-scan'),
    }

    constructor() {
        this.experience = new Experience()
        this.scroll = this.experience.ui.scroll
        this.sounds = this.experience.sounds
        this.character = this.experience.world.character

        this.addScrollEvents()
    }

    playHologramAnimation(delay = 0) {
        if (!this.hologramPlayed) {
            this.hologramPlayed = true

            this.isAnimating = true
            gsap.delayedCall(.9, () => this.isAnimating = false)

            gsap.delayedCall(.3, () => this.sounds.play('hologram'))

            this.animateProfilePanel(delay)
            this.animateSkillsPanel(delay + this.parameters.skillsAdditionalDelay)
            this.animateBioPanel(delay + this.parameters.aboutAdditionalDelay)
        }
    }

    revealPanel(panel, delay) {
        gsap.fromTo(panel,
            { opacity: 0, clipPath: 'inset(0 100% 0 0)' },
            { opacity: 1, clipPath: 'inset(0 0% 0 0)', duration: .6, ease: Power2.easeOut, delay: delay }
        )
    }

    fadeInItems(items, delay) {
        gsap.fromTo(items,
            { opacity: 0, y: 8 },
            { opacity: 1, y: 0, duration: .4, stagger: .08, ease: Power2.easeOut, delay: delay }
        )
    }

    animateProfilePanel(delay) {
        this.revealPanel(this.domElements.profile, delay)

        gsap.fromTo(this.domElements.avatar,
            { clipPath: 'inset(100% 0 0 0)' },
            { clipPath: 'inset(0% 0 0 0)', duration: .8, ease: Power2.easeInOut, delay: delay + .2 }
        )
        gsap.fromTo(this.domElements.avatarScan,
            { opacity: 1, yPercent: 0 },
            { yPercent: -420, duration: .8, ease: Power2.easeInOut, delay: delay + .2 }
        )
        gsap.to(this.domElements.avatarScan, { opacity: 0, duration: .3, delay: delay + 1 })

        this.fadeInItems(this.domElements.profile.querySelectorAll('.about-identity > *, .about-data-item'), delay + .3)
    }

    animateSkillsPanel(delay) {
        this.revealPanel(this.domElements.skills, delay)
        this.fadeInItems(this.domElements.skills.querySelectorAll('.about-skill'), delay + .25)
    }

    animateBioPanel(delay) {
        this.revealPanel(this.domElements.bio, delay)
        this.fadeInItems(this.domElements.bio.querySelectorAll('.about-log-item, .about-actions'), delay + .25)

        gsap.fromTo(this.domElements.bio.querySelectorAll('.about-log-icon img'),
            { clipPath: 'inset(0 0 100% 0)' },
            { clipPath: 'inset(0 0 0% 0)', duration: .5, stagger: .1, ease: Power2.easeOut, delay: delay + .3 }
        )
    }

    addScrollEvents() {
        new ScrollEvent({
            element: document.getElementById('books-section'),
            direction: 'up',
            f: () => {
                this.playHologramAnimation(.1)
                this.resetCharacterToPosition()
            },
            repeats: true,
        })
    }

    resetCharacterToPosition() {
        if (!this.experience.ui.landingPage.visible && this.character.body.model.position.y != -18.95 && !this.experience.ui.landingPage.isAnimating) {
            //Animation
            if (this.character.animations.actions.current._clip.name != 'water-idle')
                this.character.animations.play('waterIdle', 0)

            this.character.body.model.position.y = -18.95
            this.character.body.updateWireframe('down')
            this.character.body.model.scale.set(1, 1, 1)
        }
    }

    resize() {
        this.addScrollEvents()
    }
}
